import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Event,
  NavigationEnd,
  Router,
} from '@angular/router';
import { Breadcrumb } from '@rivethealth/data/breadcrumb';
import { flatMap } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  @Input()
  customBreadcrumbs?: Breadcrumb[];

  @Output()
  customBreadcrumbClick = new EventEmitter<number>();

  breadcrumbs: Breadcrumb[];

  private navigationSubscription: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnDestroy() {
    this.navigationSubscription.unsubscribe();
  }

  ngOnInit() {
    this.refresh();
    this.navigationSubscription = this.router.events.subscribe(
      (event: Event) => {
        if (event instanceof NavigationEnd) {
          this.refresh();
        }
      },
    );
  }

  refresh() {
    if (this.customBreadcrumbs) {
      this.breadcrumbs = this.customBreadcrumbs;
    } else {
      this.breadcrumbs = [];
      for (
        let current: ActivatedRouteSnapshot | null = this.route.snapshot.root;
        current;
        current = current.firstChild
      ) {
        if (!current.routeConfig) {
          continue;
        }
        const { data, resolve } = current.routeConfig;
        let title;
        if (data && data.breadcrumb) {
          title = data.breadcrumb;
        } else if (resolve && resolve.breadcrumb) {
          title = current.data.breadcrumb;
        } else {
          continue;
        }
        this.breadcrumbs.push({
          title,
          url: `/${flatMap(current.pathFromRoot, snapshot =>
            snapshot.url.map(segment => segment.path),
          ).join('/')}`,
          phi: !!data?.phi,
        });
      }
      this.cdr.markForCheck();
    }
  }
}
